import { render, staticRenderFns } from "./TabVisualizacaoFormando.vue?vue&type=template&id=afa99f16"
import script from "./TabVisualizacaoFormando.vue?vue&type=script&lang=js"
export * from "./TabVisualizacaoFormando.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports